import {
    GET_CONTENT_BY_TAG,
    GET_CONTENT_BY_TAG_SUCCEEDED,
    SEARCH_ENTITY_IN_SITE,
    SEARCH_ENTITY_IN_SITE_SUCCEEDED,
    ADD_MOVIE_TO_FAVORITE_FROM_SEARCH,
    ADD_ARTICLE_FROM_FAVORITE_FROM_SEARCH,
    REMOVE_MOVIE_FROM_FAVORITE_FROM_SEARCH,
    REMOVE_ARTICLE_FROM_FAVORITE_FROM_SEARCH
} from "./types";

export const getContentByTag = (payload) => ({
    type: GET_CONTENT_BY_TAG,
    payload
});

export const getContentByTagSucceeded = (payload) => ({
    type: GET_CONTENT_BY_TAG_SUCCEEDED,
    payload
});

export const searchEntityInSite = (payload) => ({
    type: SEARCH_ENTITY_IN_SITE,
    payload
});

export const searchEntityInSiteSucceeded = (payload) => ({
    type: SEARCH_ENTITY_IN_SITE_SUCCEEDED,
    payload
});

export const addMovieToFavorite = (payload) => ({
    type: ADD_MOVIE_TO_FAVORITE_FROM_SEARCH,
    payload
})

export const addArticleToFavorite = (payload) => ({
    type: ADD_ARTICLE_FROM_FAVORITE_FROM_SEARCH,
    payload
})

export const removeMovieFromFavorite = (payload) => ({
    type: REMOVE_MOVIE_FROM_FAVORITE_FROM_SEARCH,
    payload
})

export const removeArticleFromFavorite = (payload) => ({
    type: REMOVE_ARTICLE_FROM_FAVORITE_FROM_SEARCH,
    payload
})


// WEBPACK FOOTER //
// ./src/SHARED/actions/searchresults.actions.js